// extracted by mini-css-extract-plugin
export default {"contents":"fE-z","sectionHeading":"gE-z"};